// extracted by mini-css-extract-plugin
export var infoRow = "_uo-2";
export var labelContainer = "_uo-0";
export var rightInfo = "_uo-1";